export const ideasData = [
  {
    id: "birdclef-2026",
    title: "BirdCLEF+ 2026",
    category: "Bioacoustics & Soundscape AI",
    dotColor: "bg-blue-500",
    summary: "First Kaggle competition entry on audio bioacoustic species classification. Reached rank 2151/4095 (Top ~52.5%) with a 0.92207 V5 score using Google Perch v2 embeddings and ProtoSSM State Space Models.",
    description: "Automated bioacoustic monitoring and classification systems for biodiversity telemetry using State Space Models and Google Perch v2.",
    status: "Rank 2151/4095 (Score: 0.92207)",
    date: "March - June 2026",
    pdfPath: null,
    fileName: null
  },
  {
    id: "forgetting-curve-in-ai",
    title: "Synthesis Paper: The Forgetting Paradox",
    category: "Neuroscience x Machine Learning",
    dotColor: "bg-purple-500",
    summary: "How the brain's memory system is built to forget - and what that might mean for AI. A comparative analysis of biological memory destabilization and computational learning.",
    description: "Applying biological memory decay and synaptic pruning theories to neural network architectures to optimize long-term memory retention and prevent catastrophic interference in LLMs.",
    status: "Published Synthesis",
    date: "June 2026",
    pdfPath: "/research/The_Forgetting_Paradox.pdf",
    fileName: "The_Forgetting_Paradox.pdf"
  },
  {
    id: "phd-trajectory",
    title: "PhD Trajectory & Research Proposal",
    category: "Academic Planning & HCI",
    dotColor: "bg-emerald-500",
    summary: "Drafting graduate research proposals focused on using neural telemetry and cognitive metrics to model human attention and recovery patterns.",
    description: "Academic proposal for graduate research at the intersection of computer science, neuroscience, and cognitive psychology.",
    status: "Drafting Proposal",
    date: "Fall 2026",
    pdfPath: null,
    fileName: null
  }
];
